
export const whatWeDoLists: { title: string, id:number }[] = [
    { 
        id: 1,
        title: `We promote and protect trade, commerce and manufacturing, export and professional
         with Africa and the Caribbean`, 
    },
    { 
        id: 2,
        title: ` We watch and protect the general commercial interests
                 within the Africa and the Caribbean of persons engaged in trade, 
                 commerce or industry`, 
    },
    { 
        id: 3,
        title: `We consider all question connected with trade,commerce and relating to manufacturers`, 
    },
    { 
        id: 4,
        title: `We collect and circulate statistics and other information relating to trade, commerce and industry.`, 
    },
    { 
        id: 5,
        title: `We establish a commercial,economic and statistical library and to help for the
               development of commercial education by starting educational institution or otherwise`, 
    },
    { 
        id: 6,
        title: `We consider legislative and other governmental measures affecting trade, 
                commerce or industry and make representation to government and make suggestion
                 on grievances,if any`, 
    },
    { 
        id: 7,
        title: `We adjudicate controversies between members of the chambers`, 
    },
    { 
        id: 8,
        title: `We aribitrate in the settlement of disputes arising out of commercial transactions
                between parties willing or agreeing to abide by the judgement and decision`, 
    },
    { 
        id: 9,
        title: `We form a code or codes or practice to simplify and facilitate transactions 
                of business and maintain uniformity in rules,reputations and usages of trade`, 
    },
    { 
        id: 10,
        title: `We communicate with mercantile and public bodies and concerns and promote measures for the protection
                of trade and commerce and manufacturers and persons engaged there in.`, 
    },
] 